import {Component, Input, ViewEncapsulation} from '@angular/core';
import {CoreSidebarService} from '@core/components/core-sidebar/core-sidebar.service';
import {RoleDetail} from '../signing-page/signing-page.dto';
@Component({
  selector: 'app-signing-sidebar',
  templateUrl: './signing-sidebar.component.html',
  styleUrls: ['./signing-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class SigningSidebarComponent {
  @Input() roleId:string;
  @Input() document_id:number;
  @Input() is_sender:number;
  @Input() roleDetail: RoleDetail;
  @Input() view: string = 'signingArea'; // 'documentArea'


  constructor(private _coreSidebarService: CoreSidebarService) { 
   
  }

  toggleSidebar(name): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
    document.body.classList.remove('sidebar-opened');
  }
}
